import { FC } from 'react';
import { Bounce, ToastContainer } from 'react-toastify';
import IcoCloseRound from '@/assets/svg/ico_close_round.svg?react';
import IcoInfoRound from '@/assets/svg/ico_info_round.svg?react';
import IcoSuccess from '@/assets/svg/ico_success.svg?react';
import Button from '@/components/controls/Button/Button.component';

const ToastifyContainer: FC = () => (
    <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
        icon={({ type }) =>
            type === 'success' ? <IcoSuccess /> : <IcoInfoRound />
        }
        closeButton={({ closeToast }) => (
            <Button
                isCustom
                type="button"
                className="flc Toastify__custom-close-button"
                aria-label="Закрыть уведомление"
                dataTest="toast_close_button"
                clickHandler={closeToast}
            >
                <IcoCloseRound />
            </Button>
        )}
    />
);

export default ToastifyContainer;
